import { DateTime } from "luxon"

import type { DataPointReport } from "../types/reportTypes.ts"

export const getRowCount = (report: DataPointReport) => {
  let start: DateTime<true> | DateTime<false> = DateTime.now()
  let end: DateTime<true> | DateTime<false> = DateTime.now()
  const range = report.range
  const interval = report.interval
  switch (range.$type) {
    case "constant": {
      start = DateTime.fromJSDate(range.start)
      end = DateTime.fromJSDate(range.end)
      break
    }
    case "fromNow": {
      start = DateTime.now().minus({ seconds: range.returnRange })
      break
    }
    case "periodic": {
      if (range.current) {
        start = DateTime.now().startOf(range.period)
        end = DateTime.now().endOf(range.period)
      } else {
        if (!range.period) return 0
        start = DateTime.now()
          .minus({ [range.period + "s"]: 1 })
          .startOf(range.period)
        end = DateTime.now()
          .minus({ [range.period + "s"]: 1 })
          .endOf(range.period)
      }
      break
    }
  }

  return Math.ceil(end.diff(start, "seconds").seconds / interval)
}
